<template>
	<v-dialog
		v-model="show"
		max-width="600"
	>
		<template #activator="{ on }">
			<v-btn
				outlined
				small
				v-on="on"
			>
				Добавить город
			</v-btn>
		</template>

		<v-card>
			<v-card-title>Добавление города</v-card-title>
			<v-card-text>
				<v-form @submit.stop.prevent="submit">
					<v-text-field
						v-model="form.name"
						name="name"
						label="Название"
						outlined
						dense
					/>
					<v-text-field
						v-model="form.rate_per_hour"
						name="rate_per_hour"
						label="Стоимость нормо-часа"
						type="number"
						outlined
						dense
					/>
					<v-btn
						type="submit"
						color="green"
						outlined
					>
						Сохранить
					</v-btn>
				</v-form>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
const EMPTY_FORM = () => ({
	name: '',
	rate_per_hour: 0,
});

export default {
	name: 'CreateCityModal',
	data: () => ({
		show: false,
		loading: false,
		form: EMPTY_FORM(),
	}),
	methods: {
		async submit() {
			if (this.loading) return;
			this.loading = true;
			try {
				await this.$http.post('/api/v2/service/cities', this.form);
				this.$notify('Город добавлен');
				this.$emit('created');
				this.show = false;
			} catch (e) {
				this.$notify.error(e.message);
			} finally {
				this.loading =false;
			}
		},
	},
};
</script>

<style scoped>

</style>
